export default __webpack_public_path__ + "static/service-img-sm-2f1486ce362eff3462ea9e71b79dfa00.png";